import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield, Lock, CreditCard, ChevronDown, Gift, CheckCircleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OrderBump } from './OrderBump';
export function Pricing() {
  const [bumpAdded, setBumpAdded] = useState(false);
  const includes = [{
    item: 'Networker Magnético — Plan de 7 Días',
    value: '$67'
  }, {
    item: 'Bono #1: 30 Ganchos Virales',
    value: '$19'
  }, {
    item: 'Bono #2: Plantillas de Canva para Reclutamiento',
    value: '$27'
  }, {
    item: 'Bono #3: Guía Anti-Objeciones',
    value: '$25'
  }];
  const total = bumpAdded ? 24 : 17;
  return <section id="pricing-section" className="bg-brand-dark px-6 py-20 md:py-28 relative overflow-hidden" data-id="element-153">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-brand-gold/10 blur-[80px] rounded-full pointer-events-none" data-id="element-154"></div>

      <div className="mx-auto max-w-4xl relative z-10" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-darker border-2 border-brand-gold rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(212,168,67,0.15)]" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-157">
            Obtén el Sistema Completo Hoy
          </h2>

          <div className="text-lg text-slate-300 mb-10 max-w-2xl mx-auto space-y-4" data-id="element-158">
            <p data-id="element-159">
              El mes pasado gastaste más en muestras de producto, en gasolina
              para ir a presentaciones o en llamadas que nadie contestó que lo
              que cuesta este sistema.
            </p>
            <p className="text-slate-400" data-id="element-160">
              Esas inversiones no te trajeron prospectos.
            </p>
            <p className="text-white font-semibold" data-id="element-161">Este sí puede hacerlo.</p>
          </div>

          {/* What's included table */}
          <div className="w-full max-w-lg mx-auto mb-10" data-id="element-162">
            <h3 className="text-sm uppercase tracking-widest text-slate-400 font-semibold mb-4" data-id="element-163">
              Lo que incluye
            </h3>
            <div className="bg-brand-light rounded-xl border border-slate-700 overflow-hidden" data-id="element-164">
              <div className="overflow-x-auto" data-id="element-165">
                <table className="w-full text-left text-sm" data-id="element-166">
                  <thead data-id="element-167">
                    <tr className="border-b border-slate-700" data-id="element-168">
                      <th className="px-5 py-3 text-slate-400 font-medium" data-id="element-169">
                        Incluido
                      </th>
                      <th className="px-5 py-3 text-slate-400 font-medium text-right" data-id="element-170">
                        Valor
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-171">
                    {includes.map((row, i) => <tr key={i} className="border-b border-slate-800/50 last:border-b-0" data-id="element-172">
                        <td className="px-5 py-3 text-slate-200 flex items-center gap-2" data-id="element-173">
                          <span className="text-green-400" data-id="element-174">✅</span> {row.item}
                        </td>
                        <td className="px-5 py-3 text-slate-400 text-right whitespace-nowrap" data-id="element-175">
                          {row.value}
                        </td>
                      </tr>)}
                  </tbody>
                  <tfoot data-id="element-176">
                    <tr className="border-t border-slate-700" data-id="element-177">
                      <td className="px-5 py-3 text-white font-bold" data-id="element-178">TOTAL</td>
                      <td className="px-5 py-3 text-white font-bold text-right" data-id="element-179">
                        <span className="line-through text-slate-500" data-id="element-180">
                          $138
                        </span>
                      </td>
                    </tr>
                    <tr className="bg-brand-gold/10" data-id="element-181">
                      <td className="px-5 py-3 text-brand-gold font-extrabold text-base" data-id="element-182">
                        HOY
                      </td>
                      <td className="px-5 py-3 text-brand-gold font-extrabold text-base text-right" data-id="element-183">
                        $17
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <p className="text-xs text-slate-500 mt-2 md:hidden text-center" data-id="element-184">
              ← Desliza para ver la tabla completa →
            </p>
          </div>

          {/* Price block */}

          {/* CTA below price */}
          <div className="flex flex-col items-center gap-3 mb-8" data-id="element-185">
            <CTAButton text={`QUIERO TODO POR SOLO $${total} — ACCESO INMEDIATO`} href={bumpAdded ? 'https://prospectflow.store/cart/47665871061250:1' : 'https://prospectflow.store/cart/47665212293378:1'} className="w-full md:w-auto text-lg py-5 px-8" data-id="element-186" />
            <p className="text-slate-500 text-xs flex items-center gap-2" data-id="element-187">
              <Lock className="w-3.5 h-3.5" data-id="element-188" />
              Pago 100% Seguro · Acceso Inmediato · Garantía de 30 Días
            </p>
          </div>

          {/* Order Bump */}
          <div className="mb-6" data-id="element-189">
            <OrderBump checked={bumpAdded} onChange={setBumpAdded} data-id="element-190" />
          </div>

          {/* Price Summary */}
          <div className="w-full max-w-md mx-auto mb-8" data-id="element-191">
            <div className="bg-brand-light rounded-xl border border-slate-700 p-5 text-left space-y-3" data-id="element-192">
              <h4 className="text-white font-bold text-sm uppercase tracking-wide text-center mb-4" data-id="element-193">
                Resumen de tu orden
              </h4>

              <div className="flex justify-between items-center text-sm" data-id="element-194">
                <span className="text-slate-300" data-id="element-195">
                  Networker Magnético (Plan 7 Días)
                </span>
                <div className="flex items-center gap-2" data-id="element-196">
                  <span className="text-slate-500 line-through text-xs" data-id="element-197">
                    $67
                  </span>
                  <span className="text-white font-bold" data-id="element-198">$17</span>
                </div>
              </div>

              <div className="flex justify-between items-center text-sm" data-id="element-199">
                <span className="text-slate-300" data-id="element-200">3 Bonos Incluidos</span>
                <div className="flex items-center gap-2" data-id="element-201">
                  <span className="text-slate-500 line-through text-xs" data-id="element-202">
                    $71
                  </span>
                  <span className="text-green-400 font-bold" data-id="element-203">GRATIS</span>
                </div>
              </div>

              <AnimatePresence data-id="element-204">
                {bumpAdded && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} className="overflow-hidden" data-id="element-205">
                    <div className="flex justify-between items-center text-sm" data-id="element-206">
                      <span className="text-slate-300" data-id="element-207">
                        21 Guiones Magnéticos
                      </span>
                      <div className="flex items-center gap-2" data-id="element-208">
                        <span className="text-slate-500 line-through text-xs" data-id="element-209">
                          $21
                        </span>
                        <span className="text-white font-bold" data-id="element-210">$7</span>
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>

              <div className="border-t border-slate-700 pt-3 mt-3 flex justify-between items-center" data-id="element-211">
                <span className="text-white font-bold text-base" data-id="element-212">
                  Total hoy:
                </span>
                <motion.span key={total} initial={{
                scale: 1.15
              }} animate={{
                scale: 1
              }} className="text-brand-gold font-extrabold text-2xl" data-id="element-213">
                  ${total} USD
                </motion.span>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col items-center gap-4" data-id="element-214">
            <CTAButton text={`¡QUIERO TODO POR SOLO ${total} USD!`} href={bumpAdded ? 'https://prospectflow.store/cart/47665871061250:1' : 'https://prospectflow.store/cart/47665212293378:1'} className="w-full md:w-auto text-xl py-6 px-10" data-id="element-215" />
            <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400 font-medium" data-id="element-216">
              <div className="flex items-center gap-2" data-id="element-217">
                <Shield className="w-5 h-5 text-green-500" data-id="element-218" />
                30 días de garantía total
              </div>
              <div className="flex items-center gap-2" data-id="element-219">
                <Lock className="w-5 h-5 text-slate-300" data-id="element-220" />
                Pago 100% Seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-221">
                <CreditCard className="w-5 h-5 text-slate-300" data-id="element-222" />
                Acceso Inmediato
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}